var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTxWxFlood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.98 91.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1",
    fill: "#fff"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.24,18.53l-31.33,23a2.12,2.12,0,0,0-.86,1.71V59.79A2.13,2.13,0,0,0,11,61.53L13.05,63a23.63,23.63,0,0,0,13.73,4.19A23.58,23.58,0,0,0,40.51,63l1.81-1.25a2.12,2.12,0,0,1,2.41,0L46.54,63A24.59,24.59,0,0,0,74,63l2-1.4a2.11,2.11,0,0,0,.92-1.74V43.26a2.13,2.13,0,0,0-.87-1.71l-31.32-23A2.12,2.12,0,0,0,42.24,18.53Zm6.89,31.7H37.85a2.11,2.11,0,0,1-2.12-2.11V37.17a2.12,2.12,0,0,1,2.12-2.12H49.13a2.12,2.12,0,0,1,2.12,2.12V48.12A2.11,2.11,0,0,1,49.13,50.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.45,71.32a28.5,28.5,0,0,1-7.33-3.26,2.1,2.1,0,0,0-2.21,0,30,30,0,0,1-31.28,0,2.1,2.1,0,0,0-2.21,0,29.09,29.09,0,0,1-15.64,4.4,29.14,29.14,0,0,1-15.64-4.4,2.1,2.1,0,0,0-2.21,0,28.46,28.46,0,0,1-7.39,3.28,2.12,2.12,0,0,0-1.54,2v2.36a2.12,2.12,0,0,0,2.78,2,28.57,28.57,0,0,0,6.15-2.9,2.05,2.05,0,0,1,2.21,0,29.14,29.14,0,0,0,15.64,4.4,29.09,29.09,0,0,0,15.64-4.4,2.05,2.05,0,0,1,2.21,0,30,30,0,0,0,31.28,0,2.05,2.05,0,0,1,2.21,0,28.16,28.16,0,0,0,6.08,2.87,2.12,2.12,0,0,0,2.78-2V73.35A2.11,2.11,0,0,0,85.45,71.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.45,83.8a28.16,28.16,0,0,1-7.33-3.26,2.1,2.1,0,0,0-2.21,0,30,30,0,0,1-31.28,0,2.1,2.1,0,0,0-2.21,0,29,29,0,0,1-15.64,4.4,29.05,29.05,0,0,1-15.64-4.4,2.1,2.1,0,0,0-2.21,0,27.8,27.8,0,0,1-7.39,3.28,2.12,2.12,0,0,0-1.54,2v2.35a2.12,2.12,0,0,0,2.78,2,28.57,28.57,0,0,0,6.15-2.9,2.1,2.1,0,0,1,2.21,0,29.14,29.14,0,0,0,15.64,4.4,29.09,29.09,0,0,0,15.64-4.4,2.1,2.1,0,0,1,2.21,0,30,30,0,0,0,31.28,0,2.1,2.1,0,0,1,2.21,0A28.16,28.16,0,0,0,84.2,90.2a2.11,2.11,0,0,0,2.78-2V85.83A2.11,2.11,0,0,0,85.45,83.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75,22.67V2.21A1.88,1.88,0,0,0,73.07.32h-8.3a1.88,1.88,0,0,0-1.88,1.89V13.8L44.61.37a1.89,1.89,0,0,0-2.24,0L1.8,30.19a2.23,2.23,0,0,0-.48,3.12l2.84,3.87a2.23,2.23,0,0,0,3.12.47l35.36-26a1.44,1.44,0,0,1,1.7,0l35.36,26a2.23,2.23,0,0,0,3.12-.47l2.84-3.87a2.23,2.23,0,0,0-.47-3.12Z",
    style: {
      fill: "#fff"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxWxFlood);
export default __webpack_public_path__ + "static/media/tx_WXFlood.5379520342206a046dff41e94eab1ed6.svg";
export { ForwardRef as ReactComponent };